import React from 'react';
import { observer } from 'mobx-react';
import PollsContainer from './polls-list-container/polls-list-container';
import { useStore } from './../../store/store-provider';
import { Redirect, useParams } from 'react-router';
import { IRouteParams } from '../../pages/container/container';
import { getDefaultRoutePathByPermissions } from '../../utils/helpers/features-routes-helpers';
import './polls.scss';

const Polls = () => {
  const { permissionsStore } = useStore();
  const { isPodiumPollsEnabled } = permissionsStore;
  const { id } = useParams<IRouteParams>();
  if (isPodiumPollsEnabled() != undefined && !isPodiumPollsEnabled()) {
    const path = getDefaultRoutePathByPermissions(permissionsStore);
    return <Redirect to={`/presentation/${id}${path}`}/>;
  }

  return (
    <section className='polls-page'>
      <PollsContainer/>
    </section>
  );
};

export default observer(Polls);
